<template>
  <div
    v-loading="loading"
    class="app-main-inner"
    style="display: flex;flex-direction: column"
    element-loading-text=""
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <div class="app-main-inner-row">
      <div class="filters" />
      <div class="triggers">
        <template v-if="!isEdit">
          <el-button type="primary" @click="toAddTracking">{{ $t('SystemMaintenance.CreateStatus') }}</el-button>
          <el-button type="primary">{{ $t('SystemMaintenance.Edit') }}</el-button>
          <el-button type="danger">{{ $t('SystemMaintenance.Delete') }}</el-button>
        </template>
        <template v-else>
          <el-button type="primary">{{ $t('SystemMaintenance.Save') }}</el-button>
          <el-button type="primary" @click="toCancelSaveTracking">{{ $t('SystemMaintenance.Cancel') }}</el-button>
        </template>
      </div>
    </div>
    <div class="app-main-inner-row">
      <el-card class="box-card">
        <div slot="header">
          <span>{{ $t('SystemMaintenance.CreateStatus') }}</span>
        </div>
        <el-form ref="trackingForm" style="width:100%;" label-position="left" label-width="90px">
          <el-form-item :label="$t('SystemMaintenance.SerialNumber')">
            <el-input-number
              v-model="trackingForm.level"
              controls-position="right"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Code')">
            <el-input
              v-model="trackingForm.code"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.ChineseName')">
            <el-input
              v-model="trackingForm.codeCname"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.EnglishName')">
            <el-input
              v-model="trackingForm.codeEname"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.NodeType')">
            <!--            <cargo-advance-select-->
            <!--              :url="xx"-->
            <!--              :headers="['CODE','中文名称']"-->
            <!--              :fields="['code','chineseName']"-->
            <!--              :callback-params="{key:'countryCode'}"-->
            <!--              callback-method-type="value"-->
            <!--              :default-value="trackingForm.stateType"-->
            <!--              tag-value="code"-->
            <!--              tag-name="chineseName"-->
            <!--              :filter-tag-names="['code','chineseName']"-->
            <!--              filterable-->
            <!--              style="width:205px;"-->
            <!--              @parentCallBack="getValueFromChild"-->
            <!--            />-->
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.NodeType')">
            <el-checkbox v-model="trackingForm.published">{{ $t('SystemMaintenance.PublicOrNot') }}</el-checkbox>
          </el-form-item>
          <el-form-item label="OFFSETDAY">
            <el-input
              v-model="trackingForm.offsetDay"
            />
          </el-form-item>
          <el-form-item label="OFFSETHOUR">
            <el-input
              v-model="trackingForm.offsetHour"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Remark')">
            <el-input
              v-model="trackingForm.remark"
              type="textarea"
              :rows="3"
            />
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
export default {
  name: 'SopMsgPush',
  components: {
    cargoAdvanceSelect
  },
  data() {
    return {
      loading: false,
      isEdit: false,
      trackingForm: {
        level: '',
        stateType: '',
        code: '',
        codeCname: '',
        codeEname: '',
        published: '',
        offsetDay: '',
        offsetHour: ''
      }
    }
  },
  methods: {
    getValueFromChild() {
    },
    toAddTracking() {
      this.isEdit = true
    },
    toCancelSaveTracking() {
      this.isEdit = false
    }
  }
}
</script>

<style scoped>

</style>
